import React, { useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import { INotafiscal } from '..';
import { SITUACAO_NOTA_FISCAL } from '../../../../utils/funcoes';

type ItensNotaProps = {
  Item: INotafiscal;
};

const ItemTabela: React.FC<ItensNotaProps> = ({ Item }) => {
  const {
    CprCodigo,
    nome,
    descricao,
    CprDataPag,
    FormaPagto,
    NfeSituacao,
    NfeNumero,
    NumeroNF,
    vlrFormatado,
    NfeDataEmissao,
  } = Item;

  const montaSituacao = useCallback((): string => {
    if (NfeSituacao?.toLocaleLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA) {
      return 'text-success';
    }
    if (FormaPagto.includes('Cart')) {
      return 'text-danger';
    }
    return '';
  }, [FormaPagto, NfeSituacao]);

  if (Item)
    return (
      <tr key={CprCodigo} className={montaSituacao()}>
        <td>{nome}</td>
        <td>{descricao}</td>
        <td style={{ width: '7%', textAlign: 'end' }}>{vlrFormatado}</td>
        <td style={{ width: '8%', textAlign: 'center' }}>
          {format(parseISO(CprDataPag), 'dd/MM/yyyy')}
        </td>
        <td style={{ width: '8%', textAlign: 'center' }}>
          {NfeDataEmissao && format(parseISO(NfeDataEmissao), 'dd/MM/yyyy')}
        </td>
        <td>{FormaPagto}</td>
        <td className="align-content-end" style={{ width: '7%' }}>
          {NfeSituacao || 'Não gerada'}
        </td>
        <td style={{ width: '4%' }}>{NfeNumero || ''}</td>
        <td style={{ width: '7%' }}>{NumeroNF || ''}</td>
      </tr>
    );
  return <span />;
};

export default ItemTabela;
